import { useCallback } from 'react';

import { NOTIFICATION_TYPES } from '@components/Notification';
import { WebsocketAction } from '@clients/ek/interfaces';
import { useMytaverse } from '@providers/MytaverseProvider';
import useNotificationMessageEk from '@clients/ek/hooks/useNotificationMessage';
import { useTranslation } from 'react-i18next';
import { LeaveReasonEnum } from '@clients/ek/components/StyleStudio/LeaveStyleStudioEventNotification/interfaces';

const useStyleStudio = () => {
  const { t: translate } = useTranslation();

  const { sendMessageToUnreal } = useMytaverse();

  const { showLeaveStyleStudioEventNotification } = useNotificationMessageEk();

  return useCallback(function (reason: LeaveReasonEnum, cb?: () => void) {
    const messages = {
      [LeaveReasonEnum.UnfinishedLegacyWall]: 'leaveLegacyWall',
      [LeaveReasonEnum.UnfinishedTryOn]: 'leaveTryOn',
      [LeaveReasonEnum.UnfinishedStyleStudio]: 'leaveStyleStudio',
    };

    showLeaveStyleStudioEventNotification({
      message: translate(`notifications.styleStudio.${messages[reason]}`),
      type: NOTIFICATION_TYPES.ERROR,
      closeManually: true,
      onCancel: () => {
        sendMessageToUnreal({
          action: WebsocketAction.StyleStudioLeaveConfirmed,
          payload: false,
        });
      },
      onLeave: () => {
        sendMessageToUnreal({
          action: WebsocketAction.StyleStudioLeaveConfirmed,
          payload: true,
        });
        cb?.();
      },
    });
  }, []);
};

export default useStyleStudio;
